export default {
    elementsModal: {
        status: false,
    },
    contentLibraryModal: {
        status: false,
        location: null,
    },
    sideBySideTagsModal: {
        status: false,
    },
};
